<mat-toolbar class="header">

  <div class="header__title">
    <button class="header__title-button" mat-mini-fab (click)="openMenu()">
      <mat-icon *ngIf="!isMenuOpened" class="header__title-button-icon">menu</mat-icon>
      <mat-icon *ngIf="isMenuOpened" class="header__title-button-icon">menu_open</mat-icon>
    </button>
    <img src="../../../../../assets/images/loreal-logo.png"/>
    <h6 class="header__title-text">Customer - Business Partner Management System</h6>
  </div>
  <div class="header-toolbar">
    <app-user [user]="user$ | async" (signOut)="signOut()"></app-user>
  </div>

</mat-toolbar>
